<template>
  <div class="login-container">
    <div class="login-main">
      <div class="login-right">
        <div class="login-right_">
          <Tabs :animated="false" @on-click="changeTab">
            <TabPane label="账号登录">
              <div class="login-inputbox">
                <div class="inputbox account">
                  <input type="text" v-model="passwordLogin.account" id="account" class="input" placeholder="请输入账号/手机号/邮箱">
                </div>
              </div>
              <div class="login-inputbox">
                <div class="inputbox password">
                  <input type="password" v-model="passwordLogin.password" id="password" class="input" placeholder="请输入登录密码">
                </div>
              </div>
              <div class="login-submit" @click="handleLoginByPassword">登录</div>
            </TabPane>
            <TabPane label="短信登录">
              <div class="login-inputbox">
                <div class="inputbox account">
                  <input type="text" maxlength="11" v-model="verificationLogin.mobile" id="mobile" class="input" placeholder="请输入手机号">
                </div>
              </div>
              <div class="login-inputbox">
                <div class="">
                  <div id="embed-captcha"></div>
                  <p id="wait" class="show">正在加载验证码......</p>
                  <p id="notice" class="hide">请先完成验证</p>
                </div>
              </div>
              <div class="login-inputbox">
                <div class="inputbox verification">
                  <input type="text" v-model="verificationLogin.verification" id="verification" class="input " placeholder="请输入短信验证码">
                </div>
                <div class="verification-btn" @click="getVerification" v-if="time===0">发送验证码</div>
                <div class="verification-btn" @click="getVerification" v-else>{{time}}s后重新发送</div>
              </div>
              <div class="login-submit" @click="handleLoginByCode">登录</div>
            </TabPane>
          </Tabs>
          <div class="rememberbox">
            <label for="remember">
              <input type="checkbox" v-model="remember" id="remember">记住登录状态
            </label>
          </div>
          <div class="forgetlink"><router-link to="/forget">忘记密码？</router-link></div>
        </div>
      </div>
      <div class="login-left">
        <div class="login-logo" v-if="logo.length>0" :style="'backgroundImage:url(' + domainNameH5 + '/' + logo[0].picurl + ')'"></div>
        <div class="login-register-tip">
          第一次了解我们，您可以创建一个账号。
          创建成功后，您可以登陆网站预约您需要的服务！
        </div>
        <router-link to="/register" class="login-register-btn">立即注册</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { baseUrl } from '../../config/env'
import { getHeaderData, getLogoData } from '../../api/getData'
import { getLoginCode } from '../../api/login'
import { validateMobile } from '../../assets/js/validate.js'
export default {
  name: 'login',
  data () {
    return {
      headerInfo: {},
      passwordLogin: {
        account: '',
        password: ''
      },
      verificationLogin: {
        mobile: '',
        verification: ''
      },
      remember: false,
      captchaObj: {},
      time: 0,
      logo: []
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  created () {
    this.getHeaderInfo()
    this.getLogoInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
    },
    changeTab () {
      this.getSlideCodeMobile()
    },
    async getLogoInfo () {
      let postdata = { id: 2 }
      let logoResult = await getLogoData(postdata)
      this.logo = logoResult.logo
    },
    async handleLoginByPassword () {
      if (this.verification()) {
        let self = this
        let postData = {}
        postData.username = this.passwordLogin.account
        postData.password = this.encrypt(this.passwordLogin.password)
        postData.remember = this.remember
        let data = await this.$store.dispatch('LoginByPassword', postData)
        if (data === 'success') {
          self.$router.push({ path: '/' })
        } else {
          this.message('账号或密码错误')
        }
      }
    },
    async handleLoginByCode () {
      let captchaObj = this.captchaObj
      if (this.verification2()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice')[0].className = 'show'
          setTimeout(function () {
            $('#notice')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          if (this.verificationLogin.verification === '') {
            this.message('请输入验证码')
            return false
          }
          let self = this
          let postData = {}
          postData.mobile = this.verificationLogin.mobile
          postData.vercode = this.verificationLogin.verification
          postData.remember = this.remember
          let data = await this.$store.dispatch('LoginByCode', postData)
          if (data === 'success') {
            self.$router.push({ path: '/' })
          } else {
            this.message(data)
          }
        }
      }
    },
    async getVerification () {
      let self = this
      if (this.time !== 0) {
        return false
      }
      let captchaObj = this.captchaObj
      if (this.verification2()) {
        let validate = captchaObj.getValidate()
        if (!validate) {
          $('#notice')[0].className = 'show'
          setTimeout(function () {
            $('#notice')[0].className = 'hide'
          }, 2000)
          return false
        } else {
          let postData = {}
          postData.mobile = this.verificationLogin.mobile
          postData.geetest_challenge = $('input[name="geetest_challenge"]').val()
          postData.geetest_validate = $('input[name="geetest_validate"]').val()
          postData.geetest_seccode = $('input[name="geetest_seccode"]').val()
          let result = await getLoginCode(postData)
          if (result.code === '1') {
            this.time = 60
            let t = setInterval(function () {
              self.time = self.time - 1
            }, 1000)
            setTimeout(function () {
              clearInterval(t)
            }, 60000)
            this.message('验证码发送成功')
          } else {
            this.message('验证码发送失败')
          }
        }
      }
    },
    verification () {
      if (this.passwordLogin.account === '') {
        this.message('请输入账号/手机号/邮箱')
        return false
      }
      if (this.passwordLogin.password === '') {
        this.message('请输入登录密码')
        return false
      }
      return true
    },
    verification2 () {
      if (this.verificationLogin.mobile === '') {
        this.message('请输入手机号')
        return false
      }
      if (!validateMobile(this.verificationLogin.mobile)) {
        this.message('手机号格式不正确')
        return false
      }
      return true
    },
    encrypt (pwd) {
      let pubkey = '-----BEGIN PUBLIC KEY-----'
      pubkey += 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqtcivu827OwO3XQZPpjI'
      pubkey += 'xv3sf3ar0wYkjk6k2XeYJVhyUmqR8r5tpsiLsUhsXwAEA0hjPLkVGHx6ms9A9Tbd'
      pubkey += 'PAji3/WygeCb3SwB3dK85thQlNfGmOS/dtxaUguWU1bZDHN0xldJEVzQFdzpRtce'
      pubkey += 'rTRLyZnYc/SVhUdlhORKDgfu7+ZsH2Xwi8gO3LdqABeukeqqOqnmEtxRIzVWNJsV'
      pubkey += '6TR+2exwxlS5D6B7jEOmBUCvGsNi7xBaQYgXg8aH87CP4pNdueBvCDAIB5oB6zVg'
      pubkey += 'mrVxG909H8pKMZp+4A0AmjXOgTzEhnZ5dB2WHUZT1XvC8CugW/T5U2AX9x0am1+5'
      pubkey += 'aQIDAQAB'
      pubkey += '-----END PUBLIC KEY-----'
      let encrypt = new JSEncrypt()
      encrypt.setPublicKey(pubkey)
      let encrypted = encrypt.encrypt(JSON.stringify({ 'encrypt': 'yes', 'password': pwd }))
      return encrypted
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    },
    handlerEmbedMobile (captchaObj) {
      this.captchaObj = captchaObj
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      $('#embed-captcha').html('')
      captchaObj.appendTo('#embed-captcha')
      captchaObj.onReady(function () {
        $('#wait')[0].className = 'hide'
      })
    },
    getSlideCodeMobile () {
      let self = this
      $.ajax({
        // 获取id，challenge，success（是否启用failback）
        url: baseUrl + '/Verify/Start?t=' + (new Date()).getTime(), // 加随机数防止缓存
        type: 'get',
        dataType: 'json',
        success: function (data) {
          // 使用initGeetest接口
          // 参数1：配置参数
          // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它做appendTo之类的事件
          initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            new_captcha: data.new_captcha,
            product: 'embed', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
            offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
          }, self.handlerEmbedMobile)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .login-container{
    padding: 116px 0;
    background-image: url("../../assets/images/login-bg.jpg");
    background-repeat: no-repeat;
    background-position: center top;
  }
  .login-main{
    width: 1300px;
    height: 730px;
    margin: 0 auto;
    overflow: hidden;
    .login-right{
      position: relative;
      float: right;
      width: 61.7%;
      height: 100%;
      padding: 113px 0 0;
      background-color: #ffffff;
      border-bottom-right-radius: 28px;
      border-top-right-radius: 28px;
      .login-right_{
        width: 490px;
        margin: 0 auto;
        .ivu-tabs{
          overflow: inherit;
        }
        .login-inputbox{
          width: 100%;
          height: 50px;
          border-radius: 25px;
          margin-bottom: 30px;
          .inputbox{
            width: 100%;
            height: 100%;
            padding-left: 65px;
            border-radius: 25px;
            box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
            background-image: url("../../assets/images/icons.png");
            background-repeat: no-repeat;
            &.account{
              background-position: -322px -37px;
            }
            &.password{
              background-position: -321px -197px;
            }
            &.verification{
              float: left;
              width: 71.42%;
              background-position: -322px -82px;
            }
            .input{
              width: 100%;
              height: 100%;
              padding-right: 30px;
              border-bottom-right-radius: 25px;
              border-top-right-radius: 25px;
              font-size: 18px;
              line-height: 50px;
              color: #999999;
            }
          }
          .verification-btn{
            float: right;
            width: 26.53%;
            height: 100%;
            border-radius: 25px;
            box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
            font-size: 18px;
            line-height: 50px;
            text-align: center;
            color: #008489;
            cursor: pointer;
          }
        }
        .login-submit{
          width: 100%;
          height: 50px;
          border-radius: 25px;
          background-color: #ec6420;
          box-shadow: 0px 0px 7.47px 1.53px rgba(4, 0, 0, 0.15);
          margin-top: 60px;
          font-size: 24px;
          line-height: 50px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
          transition: all 0.5s ease 0s;
          &:hover{
            background-color: #e5540c;
          }
        }
        .rememberbox{
          margin-top: 17px;
          font-size: 14px;
          line-height: 38px;
          color: #222222;
          input[type='checkbox']{
            float: left;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin: 9px 13px 0 9px;
            background: url("../../assets/images/icons.png") no-repeat -350px 0;
            appearance: none;
            &:checked{
              background: url("../../assets/images/icons.png") no-repeat -410px 0;
            }
          }
        }
        .forgetlink{
          position: absolute;
          bottom: 50px;
          left: 0;
          width: 100%;
          font-size: 20px;
          line-height: 38px;
          text-align: center;
          a{
            color: #ec6420;
            &:hover{
              text-decoration: underline;
            }
          }
        }
      }
    }
    .login-left{
      float: left;
      width: 38.3%;
      height: 100%;
      padding: 58px 0 0;
      background-image: url("../../assets/images/login-left.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      .login-logo{
        width: 130px;
        height: 130px;
        margin: 50px auto 0;
        background-repeat: no-repeat;
        background-position: center;
      }
      .login-register-tip{
        width: 330px;
        margin: 100px auto 0;
        font-size: 18px;
        line-height: 36px;
        color: #ffe0e0;
        text-indent: 36px;
      }
      .login-register-btn{
        display: block;
        width: 235px;
        height: 55px;
        border: 1px solid #ffffff;
        border-radius: 27px;
        margin: 65px auto 0;
        font-size: 24px;
        line-height: 53px;
        text-align: center;
        color: #ffffff;
        transition: all 0.5s ease 0s;
        &:hover{
          background-color: #ffffff;
          color: #eb6420;
        }
      }
    }
  }
  .show {
    display: block;
  }
  .hide {
    display: none;
  }
  #notice {
    color: red;
  }
  @media screen and (max-width: 1320px){
    .login-main{
      width: 100%;
      padding: 0 10px;
    }
  }
  @media screen and (max-width: 1200px){
    .login-container{
      padding: 25px 10px;
    }
    .login-main{
      padding: 0;
      height: auto;
      .login-right{
        position: relative;
        float: none;
        width: 100%;
        height: auto;
        padding: 32px 15px 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        .login-right_{
          width: 100%;
          padding-bottom: 25px;
          .login-inputbox{
            height: 30px;
            border-radius: 15px;
            margin-bottom: 15px;
            .inputbox{
              width: 100%;
              height: 100%;
              padding-left: 30px;
              border-radius: 15px;
              background-size: 230px auto;
              &.account{
                background-position: -161px -16px;
              }
              &.password{
                background-position: -160px -96px;
              }
              &.verification{
                background-position: -161px -39px;
              }
              .input{
                padding-right: 15px;
                border-bottom-right-radius: 15px;
                border-top-right-radius: 15px;
                font-size: 12px;
                line-height: 30px;
              }
            }
            .verification-btn{
              border-radius: 15px;
              font-size: 10px;
              line-height: 30px;
            }
          }
          .login-submit{
            height: 30px;
            border-radius: 15px;
            margin-top: 30px;
            font-size: 14px;
            line-height: 30px;
          }
          .rememberbox{
            margin-top: 18px;
            font-size: 10px;
            line-height: 18px;
            input[type='checkbox']{
              width: 10px;
              height: 10px;
              margin: 4px 6px 0 0;
              background-size: 230px auto;
              background-position: -175px 0;
              &:checked{
                background: url("../../assets/images/icons.png") no-repeat -410px 0;
                background-size: 230px auto;
                background-position: -205px 0;
              }
            }
          }
          .forgetlink{
            position: relative;
            bottom: 0;
            left: 0;
            width: 100%;
            margin-top: 32px;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
      .login-left{
        float: none;
        width: 100%;
        height: auto;
        padding: 46px 0 44px;
        .login-logo{
          width: 65px;
          height: 65px;
          margin: 0 auto;
          background-size: 65px auto;
          background-position: center;
        }
        .login-register-tip{
          width: 255px;
          margin: 26px auto 0;
          font-size: 14px;
          line-height: 25px;
          text-indent: 28px;
        }
        .login-register-btn{
          width: 120px;
          height: 30px;
          border-radius: 15px;
          margin: 50px auto 0;
          font-size: 14px;
          line-height: 28px;
        }
      }
    }
  }
</style>
<style lang="less">
  #app .login-container .ivu-tabs-bar {
    height: 55px;
    border-bottom: 3px solid #999999;
  }
  #app .login-container .ivu-tabs-nav{
    width: 100%;
    .ivu-tabs-ink-bar{
      height: 3px;
      width: 50% !important;
      background-color: #ed6a2b;
      transition: all 0.5s ease 0s;
    }
    .ivu-tabs-tab{
      width: 50%;
      margin-right: 0;
      font-size: 24px;
      line-height: 40px;
      text-align: center;
      color: #999999;
      transition: all 0.5s ease 0s;
      &:hover{
        color: #ed6a2b;
      }
    }
    .ivu-tabs-tab-active {
      color: #ed6a2b;
    }
  }
  #app .login-container .ivu-tabs-no-animation>.ivu-tabs-content{
    padding-top: 64px;
  }
  @media screen and (max-width: 1200px){
    #app .login-container .ivu-tabs-bar {
      height: 32px;
      border-bottom: 1px solid #999999;
    }
    #app .login-container .ivu-tabs-nav{
      .ivu-tabs-ink-bar{
        height: 1px;
      }
      .ivu-tabs-tab{
        font-size: 14px;
        line-height: 17px;
      }
    }
    #app .login-container .ivu-tabs-no-animation>.ivu-tabs-content{
      padding-top: 14px;
    }
  }
</style>
